// extracted by mini-css-extract-plugin
export default {"row":"UOHdIx","textNoMargin":"bu16Av","textLineHeight":"AinsX6","preWrap":"_8yxZW9","ellipsis":"LjZg6p"};